import React from "react";
import { NOTIFY_POPUP_TYPES } from "./common_widgets/notify-popup";
import { HIDE_LOADER, TOGGLE_NOTIFY_POPUP } from "./mdae-common-reducer";

export const showNotifyPopup = (dispatch, message) => {
  if (message) {
    dispatch({
      type: TOGGLE_NOTIFY_POPUP,
      data: {
        visible: true,
        height: 260,
        width: 550,
        contentHtml: () => {
          return <div>{message}</div>;
        },
        notifyPopupType: NOTIFY_POPUP_TYPES.ERROR,
        closeButtonText: "OK",
      },
    });
    dispatch({ type: HIDE_LOADER });
    return;
  }
};
